module.exports = __webpack_public_path__ + "static/media/TJ.1aaed96d.png";